import { Box, Button, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useHomeInfo } from 'services/module/home'
import { convertImage } from 'utils'

const Wrapper = styled(Box)`
  overflow: auto;
  display: flex;
  width: calc(100% - 165px);
  margin-left: 165px;
  padding-bottom: 40px;
  padding-right: 165px;
  &::-webkit-scrollbar {
    width: 6px;
    height: 12px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: #ffffff;
    width: 20px;
  }

  &:hover::-webkit-scrollbar-track {
    background: transparent;
  }
  @media (max-width: 1200px) {
    width: calc(100% - 24px);
    margin-left: 24px;
    padding-bottom: 40px;
    padding-right: 24px;
    &:hover::-webkit-scrollbar-thumb {
      background: #ffffff;
      width: 2rem;
    }
  }
  @media (max-width: 900px) {
    margin-left: unset;
    padding-right: unset;
    flex-direction: column;
    width: 100%;
    justify-content: flex-start;
    padding-left: 16px;
    padding-right: 16px;
  }
`

const DateTypography = styled(Typography)`
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: ${props => props.theme.colors.grey[50]};
  margin-top: 20px;
  margin-bottom: 8px;
  @media (max-width: 1200px) {
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    margin-top: 20px;
    margin-bottom: 8px;
  }
  @media (max-width: 900px) {
    font-size: 18px;
    line-height: 24px;
    margin-top: 16px;
    margin-bottom: 4px;
  }
`
const LabelTypography = styled(Typography)`
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: ${props => props.theme.colors.white};
  @media (max-width: 1200px) {
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
  }
  @media (max-width: 900px) {
    font-size: 20px;
    line-height: 28px;
  }
`
const NewBox = styled(Box)`
  margin-right: 20px;
  flex: 1 0 40%;
  overflow: hidden;
  cursor: pointer;
  img {
    width: 100%;
    cursor: pointer;
    transition: transform 200ms;
    :hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 900px) {
    margin-right: 0px;
    margin-bottom: 32px;
  }
`
const ImgBox = styled(Box)`
  width: 100%;
  overflow: hidden;
`
const TitleTypography = styled(Box)`
  position: relative;
  font-style: normal;
  font-weight: 700;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 56px;
  line-height: 72px;
  color: ${props => props.theme.colors.white};
  margin-bottom: 20px;
  padding-left: 165px;
  @media (max-width: 1200px) {
    padding-left: 24px;
    margin-bottom: 20px;
    font-size: 56px;
    line-height: 72px;
  }
  @media (max-width: 900px) {
    padding: 0 16px;
    font-size: 32px;
  }
`
export function WhatsNews() {
  const [showLength, setShowLength] = useState(3)
  const { info } = useHomeInfo()
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()
  return (
    <>
      <TitleTypography>Latest News</TitleTypography>
      <Wrapper>
        {info &&
          info.happended &&
          info.happended.slice(0, md ? showLength : 9999999).map((el, index) => (
            <NewBox
              key={`news${el.id}${index}`}
              onClick={() => {
                navigate(`/article/${el.relationId}`)
              }}
            >
              <ImgBox>
                <picture>
                  <source srcSet={convertImage(el.iconUrl, 600, 0)} media="(max-width: 600px)" />
                  <source srcSet={convertImage(el.iconUrl, 900, 0)} media="(max-width: 900px)" />
                  <source srcSet={convertImage(el.iconUrl, 600, 0)} media="(max-width: 1200px)" />
                  <source srcSet={convertImage(el.iconUrl, 900, 0)} media="(max-width: 1920px)" />
                  <img alt="" src={el.iconUrl} loading="lazy" />
                </picture>
                {/* <Picture url={el.iconUrl}></Picture> */}
              </ImgBox>
              <DateTypography>{dayjs(el.publishingTime).format('MMM D, YYYY')}</DateTypography>
              <LabelTypography>{el.title}</LabelTypography>
            </NewBox>
          ))}
        {md && showLength === 3 && info && info.happended.length > 3 && (
          <Button
            sx={{
              height: '58px',
              fontWeight: 500,
              fontSize: '18px',
              linHeight: '26px',
              background: theme.colors.primary[300],
            }}
            onClick={() => {
              setShowLength(9999999)
            }}
          >
            More
          </Button>
        )}
      </Wrapper>
    </>
  )
}
